"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../theme");
var useStyles = (0, _theme.makeStyles)(function () {
  return {
    indicator: {
      height: '36px',
      margin: '14px',
      marginLeft: '0px',
      backgroundColor: 'rgba(30, 135, 119, 0.1)',
      borderRadius: '20px'
    },
    tab: function tab(props) {
      return {
        minWidth: '40px',
        letterSpacing: 'normal',
        marginLeft: '0px',
        fontSize: '12px',
        fontWeight: 400,
        textAlign: 'center',
        overflow: 'visible',
        padding: '12px',
        '& > span > div': {
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textTransform: 'none',
          borderRadius: props.iconTitles && '50%',
          height: props.iconTitles && '30px',
          width: props.iconTitles && '30px',
          '& svg': {
            fontSize: '20px'
          }
        }
      };
    },
    selected: function selected(props) {
      return {
        backgroundColor: props.iconTitles && '#CDE5E2',
        '& svg': {
          color: '#1E8777'
        }
      };
    },
    notSelected: {
      '& svg': {
        color: 'rgba(34, 34, 34, 0.5)'
      }
    },
    spacer: {
      position: 'absolute',
      borderBottom: '1px solid rgba(112, 112, 112, 0.25)',
      width: '30px',
      top: '50%',
      left: '135%'
    }
  };
}, {
  name: 'StyledTabsWrapper'
});
exports.useStyles = useStyles;